export default {
  from: 'From',
  to: 'To',
  enterNameOrNumber: 'Enter Number or Name',
  typeMessage: 'Type message...',
  send: 'Send',
};
